import http from '../../services/http';
import storage from '../../services/storage';
import { setUpdateClass } from '../entities/updateClassInfo';
import { setClass } from '../entities/createClass';
import { setClassDetails } from '../entities/classDetails';
import { setInstructorsEmail } from '../entities/instructorsEmails';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { setSections } from '../entities/classInfoById';

storage.get('xAuthToken');

const path = 'api';

// url: path + "https://www.greyled.work/api/section"
////////////////////////////////////////////////////////////////////////

// Post API for Class Details Screen Section tab.

const classDetailss = ({ body, onSuccess, onError, onEnd }) => {
  return async (dispatch, getState) => {
    try {
      const { token } = getState().auth;
      const store = getState();
      const res = await http.post({
        url: path + '/section',
        headers: {
          'x-auth-token': store.auth.token,
          // "x-auth-token": token,
        },
        body,
      });
      if (onSuccess) onSuccess(res);
    } catch (err) {
      if (onError) onError(err);
    } finally {
      if (onEnd) onEnd();
    }
  };
};

//// This Is a Get API for Class Info done

const classInfo = ({ onSuccess, onError, onEnd }) => {
  return async (dispatch, getState) => {
    try {
      const store = getState();

      const res = await http.get({
        url: path + '/class/gettingclasssections',
        headers: {
          'x-auth-token': store.auth.token,
        },
      });

      dispatch(setClass(res.data.data));

      if (onSuccess) onSuccess(res);
    } catch (err) {
      //onError event firing
      if (onError) onError(err);
      //else handleErrors(err);
    } finally {
      if (onEnd) onEnd();
    }
  };
};

//// This Is a Get API for Class Info update done

const classInfoUpdate = ({ onSuccess, onError, onEnd, id = '' }) => {
  return async (dispatch, getState) => {
    try {
      const store = getState();

      const res = await http.get({
        url: path + '/class/' + id,
        headers: {
          'x-auth-token': store.auth.token,
        },
      });

      dispatch(setUpdateClass(res.data.data));
      if (onSuccess) onSuccess(res);
    } catch (err) {
      //onError event firing
      if (onError) onError(err);
      //else handleErrors(err);
    } finally {
      if (onEnd) onEnd();
    }
  };
};

//// This Is a Get API for Class Info update done

const classInfoById = ({ onSuccess, onError, onEnd, id = '' }) => {
  return async (dispatch, getState) => {
    try {
      const store = getState();

      const res = await http.get({
        url: path + '/section/' + id,
        headers: {
          'x-auth-token': store.auth.token,
        },
      });

      if (onSuccess) onSuccess(res);
      dispatch(setSections(res.data.data));
    } catch (err) {
      //onError event firing
      if (onError) onError(err);
      //else handleErrors(err);
    } finally {
      if (onEnd) onEnd();
    }
  };
};

//// This Is a Get API for Class Info update done

const createClassStartAssigning = ({ onSuccess, onError, onEnd, id = '' }) => {
  return async (dispatch, getState) => {
    try {
      const store = getState();

      const res = await http.put({
        url: path + `/class/active/${id}`,
        headers: {
          'x-auth-token': store.auth.token,
        },
      });

      // dispatch(setUpdateClass(res.data.data));
      if (onSuccess) onSuccess(res);
      // toast.success(res.data.message);
    } catch (err) {
      //onError event firing
      if (onError) onError(err);
      toast.error(err);
      //else handleErrors(err);
    } finally {
      if (onEnd) onEnd();
    }
  };
};

// This Is Get API for Class Details:

const gitClassDetails = ({ onSuccess, onError, onEnd }) => {
  return async (dispatch, getState) => {
    try {
      const store = getState();

      const res = await http.get({
        url: path + '/section',
        headers: {
          'x-auth-token': store.auth.token,
        },
      });

      // const { data, headers } = res;
      dispatch(setClassDetails(res.data.data));
      if (onSuccess) onSuccess(res);
    } catch (err) {
      //onError event firing
      if (onError) onError(err);
      //else handleErrors(err);
    } finally {
      if (onEnd) onEnd();
    }
  };
};

// GET Emails API from emails list.
const gitEmails = ({ onSuccess, onError, onEnd }) => {
  return async (dispatch, getState) => {
    try {
      const store = getState();

      const res = await http.get({
        url: path + '/teacherassistant',
        headers: {
          'x-auth-token': store.auth.token,
        },
      });

      // const { data, headers } = res;
      dispatch(setInstructorsEmail(res.data.data));
      if (onSuccess) onSuccess(res);
    } catch (err) {
      //onError event firing
      if (onError) onError(err);
      //else handleErrors(err);
    } finally {
      if (onEnd) onEnd();
    }
  };
};

const getClasses = ({ onSuccess, onError, onEnd }) => {
  return async (dispatch, getState) => {
    try {
      const store = getState();

      const res = await http.get({
        url: path + '/teacherassistant/individualclass',
        headers: {
          'x-auth-token': store.auth.token,
        },
      });

      if (onSuccess) onSuccess(res.data);
    } catch (err) {
      if (onError) onError(err);
    } finally {
      if (onEnd) onEnd();
    }
  };
};

const getBooksListing = ({ page = 1, sort_by = '', class_id = '', onSuccess, onError, onEnd }) => {
  return async (_, getState) => {
    try {
      const store = getState();

      const res = await http.get({
        url: path + `/teacherassistant/filterbooks?sort_by=${sort_by}&class_id=${class_id}&page=${page}`,
        headers: {
          'x-auth-token': store.auth.token,
        },
      });

      if (onSuccess) onSuccess(res.data);
    } catch (err) {
      onError?.(err);
    } finally {
      onEnd?.();
    }
  };
};

const getDraftBooks = ({ page = 1, onSuccess, onError, onEnd }) => {
  return async (_, getState) => {
    try {
      const store = getState();
      const res = await http.get({
        url: path + `/teacherassistant/draftsbook?page=${page}`,
        headers: {
          'x-auth-token': store.auth.token,
        },
      });

      if (onSuccess) onSuccess(res.data);
    } catch (err) {
      onError?.(err);
    } finally {
      onEnd?.();
    }
  };
};

const addSection = ({ onSuccess, onError, body, onEnd }) => {
  return async (dispatch, getState) => {
    try {
      const store = getState();

      const res = await http.post({
        url: path + `/teacherassistant/add-new-class-section`,
        headers: {
          'x-auth-token': store.auth.token,
        },
        body,
      });

      if (onSuccess) onSuccess(res.data);
    } catch (err) {
      onError?.(err);
    } finally {
      onEnd?.();
    }
  };
};

const addInstructor = ({ onSuccess, onError, body, onEnd }) => {
  return async (dispatch, getState) => {
    try {
      const store = getState();

      const res = await http.post({
        url: path + `/teacherassistant/add-instructor-in-section`,
        headers: {
          'x-auth-token': store.auth.token,
        },
        body,
      });

      if (onSuccess) onSuccess(res.data);
    } catch (err) {
      onError?.(err);
    } finally {
      onEnd?.();
    }
  };
};

const removeStudent = ({ onSuccess, onError, onEnd, studentId = '', sectionId = '' }) => {
  return async (_, getState) => {
    try {
      const store = getState();
      const res = await http.put({
        url: path + `/teacherassistant/remove-student?studentId=${studentId}&sectionId=${sectionId}`,
        headers: {
          'x-auth-token': store.auth.token,
        },
      });
      if (onSuccess) onSuccess(res?.data);
    } catch (error) {
      onError?.(error);
    } finally {
      onEnd?.();
    }
  };
};

const moveStudents = ({ onSuccess, onError, onEnd, body }) => {
  return async (_, getState) => {
    try {
      const store = getState();
      const res = await http.put({
        url: path + `/teacherassistant/move-student`,
        body,
        headers: {
          'x-auth-token': store.auth.token,
        },
      });
      if (onSuccess) onSuccess(res?.data);
    } catch (error) {
      onError?.(error);
    } finally {
      onEnd?.();
    }
  };
};
const associateABook = ({ onSuccess, onError, onEnd, body }) => {
  return async (_, getState) => {
    try {
      const store = getState();
      const res = await http.put({
        url: path + `/class/associatebook`,
        body,
        headers: {
          'x-auth-token': store.auth.token,
        },
      });
      if (onSuccess) onSuccess(res?.data);
    } catch (error) {
      onError?.(error);
    } finally {
      onEnd?.();
    }
  };
};

const booksList = ({ onSuccess, onError, onEnd }) => {
  return async (_, getState) => {
    try {
      const store = getState();

      const res = await http.get({
        url: path + `/teacherassistant/users-books`,
        headers: {
          'x-auth-token': store.auth.token,
        },
      });

      if (onSuccess) onSuccess(res.data);
    } catch (err) {
      onError?.(err);
    } finally {
      onEnd?.();
    }
  };
};

export { classInfo, gitEmails, booksList, addSection, getClasses, moveStudents, addInstructor, removeStudent, getDraftBooks, classDetailss, classInfoById, associateABook, gitClassDetails, classInfoUpdate, getBooksListing, createClassStartAssigning };
